module.exports = __webpack_public_path__ + "images/stickers/taco-love@2x.44bd0a0109dda0f8706d.png";